import { transformImageSrc } from '@src/quince-components/src/atoms/image/image.utils'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'
import toSHA1 from '@src/quince-site-common/src/utils/toSHA1'
import toSHA256 from '@src/quince-site-common/src/utils/toSHA256'

const parseToNumber = (input: number | string | null | undefined, fallback = 0): number => {
  try {
    const parsed = parseFloat(input?.toString() ?? '')
    return isNaN(parsed) ? fallback : parsed
  } catch (error) {
    console.error('Error parsing to number:', { input, error })
    return fallback
  }
}

const formatRevenue = (price: number | string | null | undefined): number => {
  try {
    const parsedPrice = parseToNumber(price)
    return parseFloat(parsedPrice.toFixed(2))
  } catch (error) {
    console.error('Error formatting revenue:', { price, error })
    return 0
  }
}

const formatValue = (
  price: number | string | null | undefined,
  quantity: number | string | null | undefined,
): number => {
  try {
    const parsedPrice = parseToNumber(price)
    const parsedQuantity = parseToNumber(quantity, 1)
    return parseFloat((parsedPrice * parsedQuantity).toFixed(2))
  } catch (error) {
    console.error('Error formatting value:', { price, quantity, error })
    return 0
  }
}

const processImageUrl = (url: string): string => {
  try {
    let transformedUrl = transformImageSrc(url)

    if (!transformedUrl) {
      return ''
    }

    if (transformedUrl.startsWith('http:')) {
      transformedUrl = transformedUrl.replace(/^http:/, 'https:')
    }

    return transformedUrl.startsWith('https:') ? transformedUrl : `https:${transformedUrl}`
  } catch (error) {
    console.error('Error processing image URL:', error)
    return ''
  }
}

const getSHA256Hashed = async (email?: string): Promise<string | undefined> => {
  if (!isBrowser() || !email) return
  return await toSHA256(email.trim().toLowerCase())
}

const getSHA1Hashed = async (email?: string): Promise<string | undefined> => {
  if (!isBrowser() || !email) return
  return await toSHA1(email.trim().toLowerCase())
}

const removeHyphensFromEventId = (eventId?: string): string => (eventId ? eventId.replace(/-/g, '') : '')

export { formatRevenue, formatValue, processImageUrl, getSHA256Hashed, removeHyphensFromEventId, getSHA1Hashed }
